import { useDataSubmit } from 'Simple/Data.js'

export function useOnClick(props) {
  let submit = useDataSubmit({
    viewPath: props.viewPath,
    context: 'bottom_action',
  })

  return function onClick() {
    submit({ type: 'reschedule' })
  }
}
